import React from "react";
import styled from "styled-components";
import gardenPartyImage from "./Images/GardenParty.png";
import "./App.css";

const VenueContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 1rem;
  background-color: #f5e9dd;
`;

const VenueWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid #1c4587;
  border-image: url("data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3cfilter id='noiseFilter'%3e%3cfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3e%3c/filter%3e%3crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3e%3c/svg%3e")
    1;
  border-style: solid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const TitleImage = styled.img`
  max-width: 150px;
  height: auto;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

const VenueTitle = styled.h1`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 6vmin;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5rem;
  flex-shrink: 0;
`;

const VenueSubtitle = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 1.1rem;
  font-style: italic;
  margin-bottom: 2rem;
  color: #555;
`;

const VenueContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
`;

const Section = styled.div`
  padding: 1rem 0;
  text-align: left;
`;

const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(
      to var(--direction, right),
      transparent,
      rgba(139, 121, 94, 0.4) 50%,
      rgba(139, 121, 94, 0.4)
    );
  }

  &::before {
    --direction: right;
  }

  &::after {
    --direction: left;
  }

  span {
    padding: 0 1rem;
    font-family: "Monsieur La Doulaise", cursive;
    font-size: 1.8rem;
    color: rgba(139, 121, 94, 0.6);
  }
`;

const SectionTitle = styled.h2`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  margin-top: 0;
  text-align: center;
  color: #333;
`;

const SectionText = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const LocationInfo = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;

  h3 {
    font-family: "IM Fell English", serif;
    font-size: 1.2rem;
    margin: 0 0 0.5rem 0;
    font-style: italic;
  }

  p {
    font-family: "IM Fell English", serif;
    font-size: 1rem;
    margin: 0.2rem 0;
    color: #555;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 1.5rem;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const ImageGallery = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }
`;

const GalleryImage = styled.img`
  aspect-ratio: 4/3;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const TransportGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const TransportOption = styled.div`
  text-align: center;

  h4 {
    font-family: "IM Fell English", serif;
    font-size: 1.1rem;
    margin: 0 0 0.5rem 0;
    font-style: italic;
  }

  p {
    font-family: "IM Fell English", serif;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
    color: #444;
  }
`;

const Venue = () => {
  return (
    <VenueContainer>
      <VenueWrapper>
        <TitleImage src={gardenPartyImage} alt="Garden Party" />
        <VenueTitle>The Venue</VenueTitle>
        <VenueSubtitle>Chateau de Sermizelles, Burgundy, France</VenueSubtitle>

        <VenueContent>
          <Section>
            <SectionText>
              Sermizelles is a picturesque village in the Yonne department of
              Burgundy, just a stone's throw from the historic hilltop town of
              Vézelay - a UNESCO World Heritage site famous for its stunning
              Romanesque basilica. The area sits on the edge of the Morvan
              Regional Natural Park, offering rolling hills, lush forests, and
              the gentle Cure River winding through the valley.
            </SectionText>
            <SectionText>
              Our venue is a charming chateau surrounded by this beautiful
              countryside, with stunning views, peaceful gardens, and an
              intimate setting perfect for our celebration.
            </SectionText>
            <MapContainer>
              <iframe
                src="https://www.google.com/maps?q=3+Grande+Rue,+89200+Sermizelles,+France&output=embed"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Chateau de Sermizelles, France"
              ></iframe>
            </MapContainer>
          </Section>

          <SectionDivider>
            <span>~</span>
          </SectionDivider>

          <Section>
            <SectionTitle>accommodation</SectionTitle>
            <SectionText>
              We've secured the entire property exclusively for our celebration,
              and we're so excited to share it with you! With private rooms
              across three buildings, each couple or individual will have their
              own room.
            </SectionText>
            <SectionText>
              Set within a 1.5-hectare park, the grounds feature beautiful
              gardens and play areas, two secure swimming pools, and two
              pétanque courts - all exclusively ours for the week. You'll also
              have access to the Cure River, which borders the park, should you
              prefer a natural dip.
            </SectionText>
            <SectionText>
              Your accommodation is included for the entire week, just bring
              yourself and get ready to make some unforgettable memories with
              us!
            </SectionText>
          </Section>

          <SectionDivider>
            <span>~</span>
          </SectionDivider>

          <Section>
            <SectionTitle>getting there</SectionTitle>
            <TransportGrid>
              <TransportOption>
                <h4>By Air</h4>
                <p>
                  The nearest major airports are Paris Charles de Gaulle (CDG)
                  and Paris Orly (ORY), both approximately 2.5 hours by car.
                  Lyon-Saint Exupéry (LYS) is also an option at around 2.5 hours
                  away.
                </p>
              </TransportOption>
              <TransportOption>
                <h4>By Train</h4>
                <p>
                  The nearest station is Sermizelles-Vézelay, served by regional
                  trains from Auxerre and Avallon. From Paris, take a train to
                  Auxerre or Avallon and connect to Sermizelles. We can help
                  arrange transfers from the station.
                </p>
              </TransportOption>
              <TransportOption>
                <h4>By Car</h4>
                <p>
                  From Paris, take the A6 motorway towards Lyon. Exit at Avallon
                  and follow signs to Sermizelles. The journey takes
                  approximately 2.5 hours. Free parking is available at the
                  venue.
                </p>
              </TransportOption>
              <TransportOption>
                <h4>Transfers</h4>
                <p>
                  We will be organising group transfers from Paris and the local
                  train station for guests. More details will be provided closer
                  to the date.
                </p>
              </TransportOption>
            </TransportGrid>
          </Section>

          <SectionDivider>
            <span>~</span>
          </SectionDivider>

          <Section>
            <SectionTitle>gallery</SectionTitle>
            <ImageGallery>
              <GalleryImage src="/chateau1.jpg" alt="Chateau view" />
              <GalleryImage src="/chateau2.jpg" alt="Chateau grounds" />
              <GalleryImage src="/chateau3.jpg" alt="Chateau exterior" />
              <GalleryImage src="/chateau4.avif" alt="Chateau surroundings" />
              <GalleryImage src="/chateau5.png" alt="Chateau amenities" />
              <GalleryImage src="/chateau6.jpg" alt="Chateau interior" />
            </ImageGallery>
          </Section>
        </VenueContent>
      </VenueWrapper>
    </VenueContainer>
  );
};

export default Venue;
